import _ from "@lodash";
import { DialogContent, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import React from "react";
import PDFReaderApp from "../PDFReader/PDFReaderApp";
import ImprimirPDF from "./ImprimirPDF";

const styles = () => ({
    root: {
        padding: "5px 4px",
        display: "flex",
        alignItems: "center",
        border: "1px solid #d2d2d2",
    },
});

class ImprimirDialog extends XAPPComponent {

    render() {
        const { open, openDialog, data, idrelatorio, column, label, xappRouteParams } = this.props;

        return (
            <XAPPDialog
                id="Imprimir"
                open={open !== null}
                onClose={() => openDialog(null)}
                fullWidth
                fullScreen
            >
                <div />
                <DialogContent>
                    <div className="w-full flex">
                        <div className="flex-1" />
                        <XAPPButton
                            type="Icon"
                            className=""
                            onClick={() => openDialog(null)}
                            iconProps={"justify-center"}
                            icon={"close"}
                            key={"iconCloseDialog"}
                        />
                    </div>
                    {data !== null && !_.isUndefined(column) && column.length > 0 &&
                        <ImprimirPDF
                            data={data}
                            column={column}
                            label={label}
                        />
                    }
                    {data !== null && !_.isUndefined(idrelatorio) &&
                        <PDFReaderApp
                            key={"PDFRender_Orcamento"}
                            documento={{ idrelatorio: idrelatorio, conteudo: data }}
                            xappRouteParams={xappRouteParams}
                            //idfuncionalidade={id}
                            showAssinaturaDigital={false}
                        //afterAssinatura={afterAssinatura}
                        />
                    }
                </DialogContent>
            </XAPPDialog>
        );
    }
}


export default withStyles(styles, { withTheme: true })(ImprimirDialog);
